module.exports = __webpack_public_path__ + "img/service-digital-2.b4c0be9f.png";